'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FDIUsps = undefined;
var _jsxFileName = 'src/new-business/quick-quote/usps.js';
exports.default = Usps;
var _icon = require('@marmalade/icon');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _theme = require('./theme');
var _theme2 = _interopRequireDefault(_theme);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
UspComponent.propTypes = {
  icon: _propTypes.string.isRequired,
  title: _propTypes.string.isRequired,
  text: _propTypes.string.isRequired,
  theme: _propTypes.object.isRequired
};
function UspComponent(_ref) {
  var icon = _ref.icon,
    title = _ref.title,
    text = _ref.text,
    baseTheme = _ref.theme;
  var theme = (0, _theme2.default)(baseTheme);
  return _react2.default.createElement(_glamorous2.default.Div, {
    marginBottom: theme.space_md,
    display: 'flex',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: this
  }, _react2.default.createElement(_icon.MediumPrimaryIcon, {
    type: icon,
    css: {
      marginRight: theme.space_sm,
      flex: '1 0 auto',
      color: theme[(0, _theme.quickQuoteStyle)('Icon_color')]
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18
    },
    __self: this
  }), _react2.default.createElement('div', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26
    },
    __self: this
  }, _react2.default.createElement(_glamorous2.default.H3, {
    marginBottom: theme.space_xs,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27
    },
    __self: this
  }, title), _react2.default.createElement('p', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28
    },
    __self: this
  }, text)));
}
var Usp = (0, _glamorous.withTheme)(UspComponent);
function Usps(props) {
  return _react2.default.createElement(_glamorous2.default.Div, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38
    },
    __self: this
  }, props.themeName && _react2.default.createElement('p', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40
    },
    __self: this
  }, 'At ', props.themeName, ", we\u2019re delighted to introduce you to Marmalade, who are the leading provider of insurance for young and learner drivers. Marmalade\u2019s Learner Driver Insurance is separate to the main insurance on the car, providing cover when the learner driver is behind the wheel \u2013 without affecting the car owner\u2019s insurance policy."), _react2.default.createElement(Usp, {
    icon: 'tick-in-circle',
    title: 'Instant comprehensive cover',
    text: "Get a quote and get covered in minutes to start practising your driving skills in a friend\u2019s or family member\u2019s car.",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47
    },
    __self: this
  }), _react2.default.createElement(Usp, {
    icon: 'lock',
    title: "No risk to car owner\u2019s NCD",
    text: "You, and the car owner, can be reassured that, should you need to make a claim on your Marmalade Learner or Named Young Driver Insurance, there\u2019s no risk to the car owner\u2019s No Claims Discount!",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53
    },
    __self: this
  }), _react2.default.createElement(Usp, {
    icon: 'piggy-bank',
    title: 'Affordable, flexible cover',
    text: 'Learner Insurance cover is available for 30, 60, 90 or 180 days and you may renew as often as required. 7 or 14 day renewal options are also available.',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59
    },
    __self: this
  }), _react2.default.createElement(Usp, {
    icon: 'car',
    title: 'We cover most family cars',
    text: 'Cover is available for the majority of family cars up to insurance group 32, provided the car is less than 20 years old and \xA330,000 in value',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65
    },
    __self: this
  }));
}
var FDIUsps = exports.FDIUsps = function FDIUsps(props) {
  return _react2.default.createElement(_glamorous2.default.Div, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78
    },
    __self: undefined
  }, _react2.default.createElement(FdiCoverHeading, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79
    },
    __self: undefined
  }, 'We have one more option for you'), _react2.default.createElement(FdiCoverDescription, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80
    },
    __self: undefined
  }, "Marmalade\u2019s unique ", _react2.default.createElement('b', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81
    },
    __self: undefined
  }, 'Named Young Driver Insurance'), " gives you the freedom to drive your parents\u2019 car with your own fully comprehensive policy \u2013 without risking their No Claims Discount! If you purchase with us your cover will continue, with no premium increase, due to you passing your test."), props.children, _react2.default.createElement(_glamorous2.default.Div, {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86
    },
    __self: undefined
  }, _react2.default.createElement(_glamorous2.default.Div, {
    maxWidth: 500,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87
    },
    __self: undefined
  }, _react2.default.createElement(Usp, {
    icon: 'piggy-bank',
    title: 'Earn your own No Claims Discount',
    text: 'Named Young Driver Insurance lets you start earning your own No Claims Discount even  when driving your parents\' car.',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88
    },
    __self: undefined
  }), _react2.default.createElement(Usp, {
    icon: 'lock',
    title: 'Protect your parents\' No Claims Discount',
    text: 'We hope you won\'t need to claim but, if you do, it\'s reassuring for both you and your  parents to know they won\'t lose their hard earned No Claims Discount.',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94
    },
    __self: undefined
  })), _react2.default.createElement(_glamorous2.default.Div, {
    maxWidth: 500,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101
    },
    __self: undefined
  }, _react2.default.createElement(Usp, {
    icon: 'car',
    title: 'Drive day or night with no curfews',
    text: 'Gain the freedom of the open road with no night time driving restrictions or penalties  for driving at night.',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102
    },
    __self: undefined
  }), _react2.default.createElement(Usp, {
    icon: 'car-with-telematics',
    title: 'Black box technology',
    text: 'Our clever black box technology helps you to develop safe driving skills, and you can  view your journeys instantly on your app.',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108
    },
    __self: undefined
  }))));
};
var FdiCoverHeading = _glamorous2.default.h2({
  margin: '0 16px 16px',
  '@media screen and (min-width: 360px)': {
    textAlign: 'center',
    margin: '0 0 1em'
  },
  ':after': {
    content: ' ',
    display: 'block',
    marginTop: '20px',
    height: '5px',
    width: '90px',
    backgroundColor: '#FFCC00',
    '@media screen and (min-width: 360px)': {
      margin: '20px auto 0'
    }
  }
});
var FdiCoverDescription = _glamorous2.default.p({
  margin: '0 16px 24px',
  '> b': {
    fontWeight: '700'
  },
  '@media screen and (min-width: 360px)': {
    textAlign: 'center',
    margin: '0 auto 24px',
    width: '70%'
  }
});